// @flow
import * as React from 'react';

import { withRouter, type WithRouterProps } from 'src/helpers/withRouter';
import Unsubscription from '../Unsubscription';
import UnsubscriptionCampaign from './Campaigns';

type Props = {|
  ...WithRouterProps<{| campaignSlug: string, token: string |}>,
|};
function DispatchUnsubscriptions({
  params: { campaignSlug },
}: Props): React.Node {
  if (campaignSlug) {
    return <UnsubscriptionCampaign />;
  }
  return <Unsubscription />;
}

export default (withRouter(DispatchUnsubscriptions): React.ComponentType<{||}>);
